export enum Role {
	ADMIN = 'Administrator',
	USER = 'User',
	CLIENT = 'ROLE_CLIENT'
}

export default Role;
